export const GUEST = {
  ORDERS: 'guest_orders',
  ORDERS_RESEND_LINK: 'guest_orders_resend_link',
  UPGRADE: 'guest_upgrade',
  UPGRADE_RESEND_LINK: 'guest_upgrade_resend_link',
}
